import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { registerables, ChartOptions, ChartType, ChartDataset, Chart, CategoryScale, LinearScale, LineController, PointElement, LineElement, Legend, ChartData, BarElement } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
// import { Campaign } from '../../models/campaign';
// import { RevenueData } from '../agent-dashboard/agent-dashboard.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chart',
  imports: [BaseChartDirective, CommonModule],
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.css'
})
export class ChartComponent implements OnInit, OnChanges {

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  chartVisible = true;

  ngOnChanges(changes: SimpleChanges): void {
    this.chartVisible = false;

    setTimeout(() => {
      this.chartData.labels = this.labels;
      this.chartData.datasets[0].data = this.data;
      this.chartVisible = true;
    });
  }

  @Input() labels: string[] = [];
  @Input() data: number[] = [];
  @Input() options!: ChartOptions;

  @Output() chartClickNotify = new EventEmitter<string>();

  chartData: ChartData = {
    labels: [],
    datasets: [{
      data: []
    }]
  };

  onChartClick(event: any) {
    console.log('Chart clicked!', event);

    const activePoints = event.active;
    if (activePoints && activePoints.length > 0) {
      const chartElement: any = activePoints[0];

      const label = this.labels[chartElement.index];
      const value = this.data[chartElement.index];

      console.log(`Clicked on label: ${label}, value: ${value}`);
      this.chartClickNotify.emit(label);
    } else {
      this.chartClickNotify.emit('');
    }


  }

  ngOnInit(): void {
    Chart.register(...registerables);
    this.chartData.labels = this.labels;
    this.chartData.datasets[0].data = this.data;
  }

}
